import _defineProperty from "@babel/runtime/helpers/defineProperty";
import ExpandableSectionStateless from './ExpandableSectionStateless';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ExpandableSectionStateful extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      isExpanded: !this.props.initializeCollapsed
    });
    _defineProperty(this, "toggle", () => {
      this.setState(_ref => {
        let {
          isExpanded
        } = _ref;
        return {
          isExpanded: !isExpanded
        };
      });
    });
  }
  render() {
    const {
      isExpanded
    } = this.state;
    const {
      chevronClassName,
      className,
      content,
      expandCollapsePrimaryColor,
      expandCollapseSize,
      heading,
      hideHeadingWhenExpanded
      // initializeCollapsed
    } = this.props;
    return (
      /*#__PURE__*/
      _jsx(ExpandableSectionStateless, {
        chevronClassName: chevronClassName,
        className: className,
        content: content,
        expandCollapsePrimaryColor: expandCollapsePrimaryColor,
        expandCollapseSize: expandCollapseSize,
        heading: heading,
        hideHeadingWhenExpanded: hideHeadingWhenExpanded,
        isExpanded: isExpanded,
        onClick: this.toggle
        // initializeCollapsed={initializeCollapsed}
      })
    );
  }
}
_defineProperty(ExpandableSectionStateful, "propTypes", {
  chevronClassName: PropTypes.string,
  className: PropTypes.string,
  content: PropTypes.node.isRequired,
  expandCollapsePrimaryColor: PropTypes.string,
  expandCollapseSize: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
  heading: PropTypes.node.isRequired,
  hideHeadingWhenExpanded: PropTypes.bool,
  initializeCollapsed: PropTypes.bool
});
_defineProperty(ExpandableSectionStateful, "defaultProps", {
  expandCollapseSize: 'large',
  hideHeadingWhenExpanded: false,
  initializeCollapsed: true
});